import { useTranslation } from "react-i18next";
import SearchIcon from "../../../../icons/searchIcon";
import DataTable from "../../../../components/table/dataTable";
import Paginate from "../../../../components/pagination/paginate";
import { useState } from "react";
import Popup from "../../../../components/popups/popup";
import DeleteIcon from "../../../../icons/deleteIcon";
import AddEmployee from "./addEmploye";
import EditIcon from "../../../../icons/editIcon";
import EditEmployee from "./editEmployee";
import MessagePopup from "../../../../components/popups/messagePopup";
import CircleAlertIcon from "../../../../icons/circleAlertIcon";
import BoardButton from "../../../../components/buttons/boardButton";
import { primaryColor } from "../../../../utils";

const Employees = () => {
  const { t } = useTranslation();
  const [deleteEmployee, setDeleteEmployee] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState(null);

  const tableHead = [
    { header: t("name"), accessorKey: "name" },
    { header: t("email"), accessorKey: "email" },
    { header: t("phone"), accessorKey: "phone" },
    { header: t("status"), accessorKey: "status" },
    { header: t("joinDate"), accessorKey: "joinDate" },
    { header: t("actions"), accessorKey: "actions" },
  ];
  const shipmentData = [
    {
      name: "علي ياسر",
      email: "ali.yasser@example.com",
      phone: "01012345678",
      status: "active",
      joinDate: "27/07/2024",
      actions: "تفاصيل",
    },
    {
      name: "محمد أحمد",
      email: "mohamed.ahmed@example.com",
      phone: "01023456789",
      status: "pending",
      joinDate: "28/07/2024",
      actions: "تتبع",
    },
    {
      name: "سارة خالد",
      email: "sara.khaled@example.com",
      phone: "01134567890",
      status: "in-port",
      joinDate: "29/07/2024",
      actions: "إلغاء",
    },
    {
      name: "نورا عبدالله",
      email: "nora.abdullah@example.com",
      phone: "01245678901",
      status: "delayed",
      joinDate: "30/07/2024",
      actions: "تعديل",
    },
    {
      name: "خالد عبد الرحمن",
      email: "khaled.abdelrahman@example.com",
      phone: "01056789012",
      status: "pending",
      joinDate: "31/07/2024",
      actions: "تعديل",
    },
    {
      name: "سامي إبراهيم",
      email: "samy.ibrahim@example.com",
      phone: "01167890123",
      status: "active",
      joinDate: "01/08/2024",
      actions: "تتبع",
    },
    {
      name: "ليلى حسن",
      email: "laila.hassan@example.com",
      phone: "01278901234",
      status: "not active",
      joinDate: "02/08/2024",
      actions: "عرض",
    },
    {
      name: "ليلى حسن",
      email: "laila.hassan@example.com",
      phone: "01278901234",
      status: "not active",
      joinDate: "02/08/2024",
      actions: "عرض",
    },
    {
      name: "ليلى حسن",
      email: "laila.hassan@example.com",
      phone: "01278901234",
      status: "not active",
      joinDate: "02/08/2024",
      actions: "عرض",
    },
    {
      name: "ليلى حسن",
      email: "laila.hassan@example.com",
      phone: "01278901234",
      status: "not active",
      joinDate: "02/08/2024",
      actions: "عرض",
    },
    {
      name: "ليلى حسن",
      email: "laila.hassan@example.com",
      phone: "01278901234",
      status: "not active",
      joinDate: "02/08/2024",
      actions: "عرض",
    },
  ];

  const tableData = shipmentData.map((d, i) => {
    const status = (
      <span className="py-2 w-[100px] block mx-auto rounded-lg bg-[#E6F4EF]">
        {d.status}
      </span>
    );
    const actions = (
      <div className="flex items-center justify-center gap-2">
        <span
          onClick={() => {
            setEdit(true);
            setSelected(d);
          }}
        >
          <EditIcon className="cursor-pointer" fill={primaryColor} />
        </span>
        <span
          onClick={() => {
            setDeleteEmployee(true);
            setSelected(d);
          }}
        >
          <DeleteIcon className="cursor-pointer" />
        </span>
      </div>
    );
    return {
      name: d.name,
      email: d.email,
      phone: d.phone,
      joinDate: d.joinDate,
      status,
      actions,
    };
  });
  const data = { last_page: 20 };
  const handlePagination = () => {};
  const handleDelete = () => {
    tableData.filter((em) => em.name !== selected.name);
    setDeleteEmployee(false);
  };
  return (
    <div className="min-w-full p-5 capitalize bg-white dark:bg-gray-900 rounded-2xl">
      <section className="flex border-b border-b-[#888888] pb-2 flex-wrap items-center justify-between gap-4">
        <div className="font-medium dark:text-white">{t("currentEmployees")}</div>
        <div className="flex border border-[#F9F9F9] dark:border-gray-700 focus-within:border-black dark:focus-within:border-white items-center gap-4 bg-[#F9F9F9] dark:bg-gray-800 rounded-full px-4">
          <SearchIcon />
          <input
            type="text"
            className="flex-1 py-2 bg-transparent min-w-[250px] focus:outline-none"
            placeholder={t("employeeName")}
          />
        </div>
        <BoardButton onClick={() => setShowAdd(true)} primary bg>
          {t("addEmployee")}
        </BoardButton>
      </section>

      <div className="my-5 overflow-x-auto">
        <DataTable TableHead={tableHead} TableData={tableData} />
      </div>

      {/* إضافة موظف */}
      <Popup state={showAdd} setState={setShowAdd} header={t("addNewEmployee")}>
        <AddEmployee t={t} />
      </Popup>

      {/* تعديل موظف */}
      <Popup state={edit} setState={setEdit} header={t("editEmployee")}>
        <EditEmployee t={t} selected={selected} />
      </Popup>

      {/* تأكيد حذف */}
      <MessagePopup
        state={deleteEmployee}
        setState={setDeleteEmployee}
        noTimer
        text={
          <div>
            <h1 className="text-lg font-semibold text-center capitalize">
              {t("sureToDeleteEmployee")}
            </h1>
            <p className="my-2 text-sm text-center text-mainGray dark:text-gray-200">
              {t("allDataPermanentlyDeletedUndine")}
            </p>
            <div className="flex items-center justify-center gap-4 mt-4">
              <BoardButton
                onClick={() => setDeleteEmployee(false)}
                secondary
                text
                border
                className="border"
              >
                {t("cancel")}
              </BoardButton>
              <BoardButton onClick={handleDelete} secondary bg>
                {t("confirm")}
              </BoardButton>
            </div>
          </div>
        }
        icon={<CircleAlertIcon />}
      />

      <Paginate handlePagination={handlePagination} data={data} />
    </div>
  );
};

export default Employees;
